import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-main">
        <div className="footer-content">
          <div className="footer-column">
            <h4>Shopping Online</h4>
            <ul>
              <li>
                <Link to="/terms-of-sale" onClick={toTop}>
                  Terms of Sale
                </Link>
              </li>
              <li>
                <Link to="/returns" onClick={toTop}>
                  Returns Policy
                </Link>
              </li>

              <li>
                <Link to="/shipping" onClick={toTop}>
                  Delivery Information
                </Link>
              </li>
              <li>
                <Link to="/refunds" onClick={toTop}>
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/payments" onClick={toTop}>
                  Payment & Security
                </Link>
              </li>
              <li>
                <Link to="/faqs" onClick={toTop}>
                  FAQs
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Customer Care</h4>
            <ul>
              <li>
                <Link to="/complaints" onClick={toTop}>
                  Complaints Policy
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/accessibility" onClick={toTop}>
                  Accessibility
                </Link>
              </li>
              <li>
                <Link to="/data-rights" onClick={toTop}>
                  Data Rights
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Policies & Legal</h4>
            <ul>
              <li>
                <Link to="/policies" onClick={toTop}>
                  All Policies
                </Link>
              </li>
              <li>
                <Link to="/privacy" onClick={toTop}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" onClick={toTop}>
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" onClick={toTop}>
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link to="/acceptable-use" onClick={toTop}>
                  Acceptable Use
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Responsible Business</h4>
            <ul>
              <li>
                <Link to="/ethical-trading" onClick={toTop}>
                  Ethical Trading
                </Link>
              </li>
              <li>
                <Link to="/modern-slavery" onClick={toTop}>
                  Modern Slavery Position
                </Link>
              </li>
              <li>
                <Link to="/sustainability" onClick={toTop}>
                  Sustainability
                </Link>
              </li>
              <li>
                <Link to="/anti-bribery" onClick={toTop}>
                  Anti-Bribery
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column social-column">
            <h4>Contact</h4>
            <a href="mailto:level@failblossom.lifestyle">
              level@failblossom.lifestyle
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-links">
          <Link to="/terms" onClick={toTop}>
            Terms of Use
          </Link>
          <Link to="/terms-of-sale" onClick={toTop}>
            Terms of Sale
          </Link>
          <Link to="/privacy" onClick={toTop}>
            Privacy Policy
          </Link>
          <Link to="/cookies" onClick={toTop}>
            Cookie Policy
          </Link>
          <Link to="/accessibility" onClick={toTop}>
            Accessibility
          </Link>
        </div>

        <div className="footer-currency">
          <span className="flag">🇬🇧</span>
          <span className="currency">GB / £ GBP</span>
        </div>
      </div>

      <div className="footer-copyright">
        <p>
          © failblossom 2026 All Rights Reserved · level@failblossom.lifestyle
        </p>
      </div>
    </footer>
  );
}

export default Footer;
